module.exports = __webpack_public_path__ + "media/images/uber_eats-ecf0f9f00dc7d0a62bbc524cede1fe0b.svg";